import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Subscribe.css';

const SubscribeBox = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubscribe = async () => {
    if (!email.trim()) {
      toast.error('Email is required.');
      return;
    }

    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Client-Domain': 'www.clevercoverageofficial.com',
        },
      };

      const response = await axios.post(
        'https://api.funfillia.com/api/v2/website/subscribe/store',
        { email },
        options
      );

      const messageText = response?.data?.message?.toLowerCase();

      if (messageText?.includes('already')) {
        toast.info('You are already subscribed.');
      } else {
        toast.success('Subscribed successfully!');
      }

      setEmail('');
    } catch (err) {
      console.error('Subscription error:', err);
      toast.error('Subscription failed. Try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section>
      <div className="subscribe-box">
        <h4>Subscribe Our Newsletter</h4>
        <input
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button onClick={handleSubscribe} disabled={isSubmitting}>
          {isSubmitting ? <span className="spinner"></span> : 'SUBSCRIBE NOW'}
        </button>
      </div>

      {/* Toast container */}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </section>
  );
};

export default SubscribeBox;
